
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightDeckColourOn as ObiLightDeckColourOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-deck-colour-on.js';
 
 
 

 
 export const ObiLightDeckColourOn = createComponent({
   react: React,
   tagName: 'obi-light-deck-colour-on',
   elementClass: ObiLightDeckColourOnElement,
   events: {
     
   }
  });
 
 